import { apiWrapper } from "@/services/api";
import store from "@/store";

export const putDeleteReservation = async (apiParams) => {
  try {
    const response = await apiWrapper("PUT", `/demand-cancel`, apiParams);
    console.log("putDeleteReservation response.data :>> ", response.data);
  } catch (err) {
    console.log('ERROR"" putDeleteReservation():', err);
    throw err;
  }
};
